import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const PageTitleUpdater = () => {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/aula-virtual/")) {
      document.title = `${t("appShell.virtualClassroom")}`;
    } else if (path === "/inicio") {
      document.title = `${t("appShell.home")}`;
    } else {
      document.title = `${t("appShell.virtualClassroom")}`;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return null;
};
